const ErrMsg: { [key: string]: string } = {
    // auth module
    "auth/user-not-found": "관리자가 존재하지 않습니다",
    "auth/wrong-password": "비밀번호를 정확히 입력해주세요",
    "auth/invalid-credential": "비밀번호를 정확히 입력해주세요",
    "auth/login-invalid-credential": "이메일 또는 비밀번호를 확인해주세요",
    "auth/too-many-requests": "로그인 시도가 많습니다. 잠시 후 다시 시도해주세요",
    "auth/network-request-failed": "네트워크 연결을 확인해주세요",
    "auth/user-disabled": "비활성화된 계정입니다",
    "auth/login-failed": "로그인 중 문제가 발생했습니다. 다시 시도해주세요",
    // backend module
    "auth/name-empty": "이름을 입력해주세요",
    "auth/name-invalid": "이름을 정확히 입력해주세요",
    "auth/name-weak": "이름을 정확히 입력해주세요",
    "auth/partnerId-empty": "파트너사 아이디를 입력해주세요",
    "auth/partnerId-invalid": "파트너사 아이디를 입력해주세요",
    "auth/partnerId-weak": "파트너사 아이디를 4자리 이상 입력해주세요",
    "auth/partnerId-not-found": "존재하지 않는 파트너사입니다",
    "auth/partnerId-already-in-use": "이미 존재하는 파트너사 아이디입니다",
    "auth/partnerName-empty": "파트너사 이름을 입력해주세요",
    "auth/partnerName-already-in-use": "이미 존재하는 파트너사 이름입니다",
    "auth/type-invalid": "구분을 선택해주세요",
    "auth/email-empty": "이메일을 입력해주세요",
    "auth/email-invalid": "이메일을 정확히 입력해주세요",
    "auth/email-already-in-use": "이미 사용 중인 이메일입니다",
    "auth/password-empty": "비밀번호를 입력해주세요",
    "auth/password-invalid": "비밀번호를 정확히 입력해주세요",
    "auth/password-not-match": "비밀번호가 맞지 않습니다",
    "auth/password-weak": "6자리 이상으로 입력해주세요",
    // kiosk
    "kiosk/name-invalid": "키오스크 이름을 입력해주세요",
    "kiosk/address-invalid": "주소를 입력해주세요",
    "kiosk/maxCapacity-invalid": "최대 투입 개수를 입력해주세요",
    "kiosk/photo-invalid": "사진을 선택해주세요",
    // backend module
    "kiosk/not-found": "키오스크가 존재하지 않습니다",
    // token
    "token/id-invalid": "아이디를 입력해주세요",

    //notice
    "notice/invalid-argument": "입력값이 올바르지 않습니다.",
    "notice/user-not-found": "사용자 정보가 없습니다.",
    "notice/no-partner-id": "파트너 ID가 없습니다.",
    "notice/partner-id-required": "파트너 ID는 필수입니다.",
    "notice/partner-mismatch": "권한이 없습니다.",
    "notice/not-found": "공지사항이 존재하지 않습니다.",
    "notice/doc-id-required": "공지사항 ID가 필요합니다.",
    "notice/aborted": "처리 중 문제가 발생했습니다.",
};

export default ErrMsg;
